import moment from 'moment';
import { isEqual, difference, clone } from '@/utils/helpers'
import BookingMixin from '@/mixins/bookings'
import AvailableMixin from '@/mixins/available'

const Timeline = {
  mixins: [BookingMixin, AvailableMixin],
  data () {
    return {
      timelineReady: false,
      timelineInterval: null,
      refreshTime: 60,
    }
  },
  methods: {
    onRefresh () {
      this.getBookings();
    },
    onIntervalRefresh () {
      console.log('timeline --- onIntervalRefresh');
      this.getBookings();
    },
    initTimeline (app) {
      // create a data set with groups
      app.groups = [];
      console.log('----- initTimeline ----');
      app.drivers.forEach(function (d) {
        app.groups.push({
          id: d.id,
          zip: d.zip,
          zones: d.zones,
          name: d.lastname + ' ' + d.firstname,
          content: '<div class="zone zone-' + d.zones + '"><div><span class="primary--text">' + d.id + '.</span> ' + d.lastname + ' ' + d.firstname +'</div><div style="width:100%" class="text-center caption"><span>(' + d.zip + ' ' + d.city +'</span>' +')</div></div>',
          visible: true,
          className: 'zone-' + d.zones
        });
        app.selectedDrivers = app.groups.slice();
      })
      app.timelineReady = true;
      this.getBookings();
      this.timelineInterval = setInterval(this.onIntervalRefresh, this.refreshTime * 1000);
      // console.log(this.$refs.timeline);
    },
    getBookings () {
      var app = this;
      app.$store.dispatch('getBookings').then(() => {
        console.log('timeline --- getBookings data');
        this.getAvailables(app).then(() => {
          this.parseBookings(app);
        });
      }).catch((err) => {
        console.log('timeline --- getBookings catch ...');
      }).then(() => {
        console.log('timeline --- getBookings finally ...');
        // this.updateBookings(app);
      })
    },
    parseBookings (app) {
      app.bookings.map(function (d) {
        // var distance = d.json = JSON.parse(d.distance);
        // var accepted = d.accepted === 1 ? ' acceptedClass' : (d.accepted === -1 ? ' refusedClass' : '');
        var accepted = ' acceptedClass-' + d.accepted;
        var charged = d.charged ? ' chargedClass' : '';
        var status = d.status ? ' statusClass status-' + d.status : '';

        d.waiting = d.ap_waittime ? moment.duration(d.ap_waittime) : 0;
        d.pick_time = d.pick_time || d.ap_time;
        d.ap_date = app.$options.filters.date(d.ap_date)
        d.price = d.price || d.distance.totals[d.type].price
        // d.dist = distance.totals[d.type].distance
        // d.duration = app.$options.filters.toTime(distance.totals[d.type].duration)
        d.duration = app.$options.filters.toTime(d.distance.duration)

        // var t = app.calcTimes(d, distance);
        d.start = moment(d.start);
        d.end = moment(d.end);
        d.className = d.type + 'class' + accepted + charged + status;
        d.search = d.ap_date + ' ' + d.id + ' ' + d.client_lastname + ' ' + d.client_firstname + ' ' + d.destination_name + ' ' + d.driver_firstname + ' ' + d.driver_lastname;

      });

      this.updateBookings(app);
    },
    updateBookings (app) {
      app.items = [];
      console.log('timeline --- updateBookings');
      app.bookings.forEach(function (b) {
        if (!b.start) {
          console.log('problem', b.start.format('HH:mm'));
        }

        var start_end_string = '<span class="black--text">(' + b.start.format('HH:mm') + ' - ' + b.end.format('HH:mm') + ')</span>';

        app.items.push({
          id: b.id,
          group: b.driverId,
          title: '<div class="primary--text">' + b.id + ' <span class="black--text">' + moment(b.pick_time, 'HH:mm:ss').format('HH:mm') + ' - ' + moment(b.ap_time, 'HH:mm:ss').format('HH:mm') + ' - ' + b.destination_name + ' - ' + b.client_lastname + ' ' + b.client_firstname + '</span> <br> ' + start_end_string + '</div>',
          content: '<div class="item-container motive-'+ b.motive + '"> <div><i class="v-icon material-icons ' + (b.mutualPatientID ? '' : ' noinsurance' ) + '">euro</i> ' + b.id + ' - ' + b.destination_name + ' <br><span class="group-name">' + b.client_lastname + ' ' + b.client_firstname + '</span></div></div>',
          className: b.className,
          start: b.start,
          end: b.end
        });
      })
      app.items.push(...app.backgrounds);
      this.$store.commit('SET_timelineBookings', app.items);
    },
    getDrivers () {
      var app = this;
      app.$store.dispatch('getDrivers').then((drivers) => {
        console.log('drivers data', drivers);
        this.initTimeline(app);
      });
    },
  },
  watch: {
    bookings () {
      console.log('watch: bookings ');
    },
    diffData (v) {
      v.forEach((item) => {
        if (item && item.accepted > 1) {
          // console.log('notify', item);
          const snd = (item.accepted >= 3) ? ((item.accepted === 3) ? 'not' : 'time') : 'ok';
          this.$store.commit('playSound', snd);
        }
      })
    },
    drivers (v) {
      if (v.length) {
        this.initTimeline(this);
      }
    }
  },
  computed: {
    bookings: {
      cache: false,
      get () {
        return this.$store.getters.bookings;
      }
    },
    oldData: {
      cache: false,
      get () {
        return this.$store.getters.oldData;
      }
    },
    diffData: {
      cache: false,
      get () {
        return this.$store.getters.diffData;
      }
    },
    drivers: {
      cache: false,
      get () {
        return this.$store.getters.drivers;
      }
    },
    timelineBookings: {
      cache: false,
      get () {
        return this.$store.getters.timelineBookings;
      }
    }
  },
  sockets: {
    booking_update (val) {
      console.log('timeline refresh - by the socket server: ', val);
      this.onIntervalRefresh();
    }
  },
  created () {
    if (this.drivers.length) {
      this.initTimeline(this);
    }
  },
  beforeDestroy () {
    console.log('destroy');
    this.$store.commit('CLEAR_loadingsBookings');
    clearInterval(this.timelineInterval);
    this.timelineInterval = null;
    console.log('------------------------------------ destroy');
  }
}

export default Timeline
